import { colorsPalettes, getBrightnessHEX } from "@similarweb/styles";

import type { ITrafficShareProps } from "pro-features/components/TrafficShare/src/TrafficShareWithTooltip";
import { TrafficShareWithTooltip } from "pro-features/components/TrafficShare/src/TrafficShareWithTooltip";
import { DefaultFrameLoader } from "../widgetFrames/simpleFrame";
import TranslationProvider from "pro-features/components/WithTranslation/src/TranslationProvider";
import { i18nFilter } from "app/filters/i18nFilter";

interface Item {
    metric?: string;
    bars: Array<{
        color: string;
        name?: string;
        valueText: string;
        width: number;
    }>;
}

interface MetricsCompareBarsProps
    extends Pick<ITrafficShareProps, "title" | "subTitles" | "minWidthToShowData" | "minWidthToShowDataMiddle"> {
    isFetching?: boolean;
    items: Array<Item>;
    textMinValue?: number;
}

const MetricsCompareBars = ({
    items,
    textMinValue = 3,
    isFetching,
    subTitles,
    minWidthToShowData,
    minWidthToShowDataMiddle,
    ...props
}: MetricsCompareBarsProps) => {
    const data =
        items[0] &&
        items[0].bars.map((item) => {
            return {
                color:
                    getBrightnessHEX(item.color) === "dark" ? colorsPalettes.carbon[0] : colorsPalettes.midnight[600],
                backgroundColor: item.color,
                width: item.width / 100,
                text: item.valueText,
                name: item.name,
            };
        });
    return (
        <TranslationProvider translate={i18nFilter()}>
            <div
                className="metrics-bars-container"
                {...props}
            >
                {isFetching ? <DefaultFrameLoader /> : null}
                {!isFetching ? (
                    <TrafficShareWithTooltip
                        data={data}
                        barGap={2}
                        title={props.title}
                        subTitles={subTitles}
                        minWidthToShowData={minWidthToShowData}
                        minWidthToShowDataMiddle={minWidthToShowDataMiddle}
                    />
                ) : null}
            </div>
        </TranslationProvider>
    );
};

export default MetricsCompareBars;
